<template>
  <base-hover v-slot="{ isHover }">
    <div
      class="product-item"
      :style="{
        'background-color': user.profile.institution.color,
      }"
    >
      <img
        v-srcset
        :src="img"
        alt=""
        class="product-item__image"
        :style="maxWidth"
      >
      <div
        v-if="!editMode"
        class="product-item__content"
        @dblclick="startEditing"
      >
        <p
          v-if="showBrandName"
          class="product-item__description"
        >
          {{ description || 'Add brand name' }}
        </p>
        <h3 class="product-item__title">
          {{ title || 'Add description' }}
        </h3>
      </div>
      <div
        v-else
        class="product-item__content"
      >
        <p class="product-item__description">
          <template v-if="editable">
            <input
              ref="input1"
              v-model.trim="newDescription"
              type="text"
              class="ml-1 inputs form-control"
              placeholder="Add brand name"
              @keypress.enter="stopEditing"
              @blur="onBlur"
              @focus="isFocused = true"
            >
          </template>
          <template v-else-if="showBrandName">
            {{ description || 'Add brand name' }}
          </template>
        </p>
        <h3 class="product-item__title">
          <input
            ref="input2"
            v-model.trim="newTitle"
            type="text"
            class="ml-1 inputs form-control"
            placeholder="Add description"
            style="margin-top: 4px;"
            @keypress.enter="stopEditing"
            @blur="onBlur"
            @focus="isFocused = true"
          >
        </h3>
      </div>
      <template v-if="(isHover || isIPad) && canDelete">
        <base-icon
          class="product-item__button-close"
          icon="widget-close"
          @click="$emit('close')"
        />
      <!-- <div
        class="product-item__pen-icon"
        @click.stop.prevent="$emit('edit')"
      >
        <font-awesome-icon icon="pen" />
      </div> -->
      </template>
    </div>
  </base-hover>
</template>

<script>
import utilsMixin from '@/_utilities/utilsMixin';
import whichbrowser from '@/components/mixins/whichbrowser';

export default {
  name: 'ProductItem',
  mixins: [utilsMixin, whichbrowser],
  props: {
    pk: {
      type: Number,
      required: false,
      default: 0,
    },
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    productRowWidth: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      editMode: false,
      isFocused: false,
      newDescription: '',
      newTitle: '',
    };
  },
  computed: {
    user() {
      return this.$store.state.account.user;
    },
    showBrandName() {
      return this.$store.getters['account/theme'].product_display_brand;
    },
    maxWidth() {
      if (this.productRowWidth === 3) {
        return { 'max-width': ' 220px', 'max-height': '240px !important' };
      }
      return { 'max-width': '352px', 'max-height': '350px !important', height: '350px' };
    },
  },
  watch: {
    description: {
      immediate: true,
      handler(newVal) {
        this.newDescription = newVal;
      },
    },
    title: {
      immediate: true,
      handler(newVal) {
        this.newTitle = newVal;
      },
    },
  },
  methods: {
    onBlur() {
      this.isFocused = false;

      setTimeout(() => {
        if (!this.isFocused) {
          this.stopEditing();
        }
      }, 100);
    },
    startEditing() {
      // if (!this.editable) {
      //   return;
      // }
      if (!this.useFeature('product_edit_enabled')) {
        console.log("  ('product_edit_enabled' is falsy)  ");
        return;
      }

      // this.editMode = true;
      this.$nextTick().then(() => {
        if (this.editable) {
          this.$refs.input1.focus();
        } else {
          this.$refs.input2.focus();
        }
      });
    },
    stopEditing() {
      this.editMode = false;
      const canSendUpdate = (this.isFocused === this.editMode); // This prevents double updating
      if (canSendUpdate) {
        this.$emit('edit', { pk: this.pk, description: this.newDescription, title: this.newTitle });
      }
    },
  },
};
</script>

<style lang="scss">
// @import "../styles/main.scss";
.inputs{
  border-radius: 3px;
  height: 28px;
}
.inputs:focus{
  outline: solid 2px #ABABAB;
  box-shadow: 0px 0px 0px 3px rgba(51, 51, 51, 0.12);
  border-color: #ABABAB !important;
}
.product-item{
  position: relative;
  text-align: center;

  &{
    padding: 0;
    // background: $bg-product;
    // min-width: 200px;
    margin-bottom: 1rem;
  }

  &__image{
    // margin-left: 15%;
    // width: 70%;
    // height: 400px;
    width: 100%;
    max-width: 230px;
    pointer-events: none;
    height: 230px;
    object-fit: contain;
    // height: 220px;
    // object-fit: scale-down;
  }
  &__title{
    font-size: 0.75rem;
    margin-bottom: 0;
    color: $gray-600;
    display: flex;
    justify-content: center;
  }
  &__description{
    // font-weight: bold;
    font-family: $font-family-sans-serif-medium;
    font-size: 0.75rem;
    margin-bottom: 0;
    display: flex;
    justify-content: center;
  }
  &__content{
    padding: 0.75rem;
    text-align: center;
  }
  &__content:hover{
    cursor: auto;
  }
  &__pen-icon{
    background-color: #f2f2f2;
    border-radius: 3px;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 20px 30px;
    font-size: 36px;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: all 0.2s;
  }
  &__button-close{
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 20px;
    padding: 3px 10px;
    transition: all 0.2s;
    cursor: pointer;
  }
  &:hover &__pen-icon{
    opacity: 1;
  }
}
</style>
